var _circle, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptySearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 70,
    fill: "url(#paint0_linear_5054_84610)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.1949 64.5974C86.1949 76.5254 76.5254 86.1949 64.5974 86.1949C52.6695 86.1949 43 76.5254 43 64.5974C43 52.6695 52.6695 43 64.5974 43C76.5254 43 86.1949 52.6695 86.1949 64.5974Z",
    fill: "url(#paint1_linear_5054_84610)",
    fillOpacity: 0.2,
    stroke: "#E7E8EC",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6641 79.6641L96.6121 96.6121",
    stroke: "#E7E8EC",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5054_84610",
    x1: 70,
    y1: 0,
    x2: 70,
    y2: 140,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5054_84610",
    x1: 42,
    y1: 64.5974,
    x2: 87.1949,
    y2: 64.5974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9E0FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySearch);
export default __webpack_public_path__ + "static/media/EmptySearch.dfcf3f2bf04056d7d1391724a1e2303a.svg";
export { ForwardRef as ReactComponent };